import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../store';

const selectAuth = (state: RootState) => state.auth;

export const selectIsSignUpSuccess = createSelector(selectAuth, (auth) => auth.isSignUpSuccess);
export const selectDefaultVerificationType = createSelector(selectAuth, (auth) => auth.defaultVerificationType);
export const selectChangePasswordParams = createSelector(selectAuth, (auth) => auth.changePasswordParams);
export const selectExpiredCodeTime = createSelector(selectAuth, (auth) => auth.expiredCodeTime);
